class SuddenlinkidslandingController {
  constructor($state,storage, $scope, laboxSSapi) {
    this.name = 'Usernames';
    this.state = $state;
    this.landingPageSdlIDLoader = true;
    this.hasSuddenlinkID = false;
    this.hasNoSuddenlinkID = false;
    this.totalSdlIdCount = 0;
    this.errorWhileLoading = false;
    this.currentSdlIdCount = 0;
    this.sdlPrimary = '';
    this.isMaxSuddenlink = false;

    laboxSSapi.getAllSuddenlinkIds().then((res)=>{
      console.log('res is ' + res);
      console.log('res.data.accountSummaryResponse.statusDescription is ' + res.data.accountSummaryResponse.statusDescription);
      if(res && res.data && res.data.accountSummaryResponse.statusDescription && res.data.accountSummaryResponse.statusDescription == "Success"){
        console.log('res.data.accountSummaryResponse.userCount is ' + res.data.accountSummaryResponse.userCount);
        this.unregUser = res.data.accountSummaryResponse.users[0].userName.search("unreg:") + 1;
        console.log('this.unregUser is ' + this.unregUser);
        if(res.data.accountSummaryResponse.userCount !== 0 && this.unregUser !== 1){
          this.currentSdlIdCount = res.data.accountSummaryResponse.userCount;
          if (this.currentSdlIdCount > 0) {
            storage.setItem('session','hasSuddenlinkId',true);
            this.hasSuddenlinkId = (storage.getItem('session', 'hasSuddenlinkId'));
            console.log('this.hasSuddenlinkId is ' + this.hasSuddenlinkId);
          }
          console.log("this.currentSdlIdCount is " +this.currentSdlIdCount);
          if (res.data.accountSummaryResponse.maxIdsperAcct < res.data.accountSummaryResponse.userCount) {
            this.totalSdlIdCount = res.data.accountSummaryResponse.userCount;
          } else {
            this.totalSdlIdCount = res.data.accountSummaryResponse.maxIdsperAcct;
          }
          console.log("this.totalSdlIdCount is " + this.totalSdlIdCount);
          if(parseInt(this.totalSdlIdCount) === parseInt(this.currentSdlIdCount)){
            this.isMaxSuddenlink = true;
          }
          this.sdlPrimary = res.data.accountSummaryResponse.primaryId;
          console.log("this.sdlPrimary is " +this.sdlPrimary);
          storage.setItem('session','maxIdAvailable',this.totalSdlIdCount);
          storage.setItem('session','currentSdlIdCount',res.data.accountSummaryResponse.userCount);
          this.hasSuddenlinkID = true;
          this.landingPageSdlIDLoader = false;
        }
        else if(this.unregUser === 1){
          this.hasNoSuddenlinkID = true;
          this.landingPageSdlIDLoader = false;
        }
      }
      else{
        this.errorWhileLoading = true;
        this.landingPageSdlIDLoader = false;
      }
    });

  }

}

SuddenlinkidslandingController.$inject = ['$state','storage', '$scope', 'laboxSSapi'];

export default SuddenlinkidslandingController;


// WEBPACK FOOTER //
// ./client/app/components/landingpage/suddenlinkidslanding/suddenlinkidslanding.controller.js